import axios from "axios";

export default {
  async createCustomer(formData) {
    return axios.get(`/booking-requests/${formData.id}/customer`);
  },
  async delete(formData) {
    return axios.delete(`/booking-requests/${formData.id}`);
  }
};
